import * as types from './types';
export default {
  [types.SET_LOOKBOOK](state, payload) {
    const currentState = state;
    currentState.lookbook = payload;
  },

  [types.APPEND_AMBIENCES](state, payload) {
    const currentState = state;
    const ambiences = currentState.lookbook.items;
    currentState.lookbook.items = [...ambiences, ...payload.items];
  },

  [types.PREPEND_AMBIENCES](state, payload) {
    const currentState = state;
    const ambiences = currentState.lookbook.items;
    currentState.lookbook.items = [...payload.items, ...ambiences];
  },

  [types.SET_LOADING_AMBIENCES](state, payload) {
    const currentState = state;
    currentState.loading = payload;
  }

};